<ng-template title-header [title]="'Lista Appuntamenti'"></ng-template>

<table-list
  [selected]="selected"
  (selectedChange)="selected = $event; onSelect($event)"
  [requestData]="state.requestData"
  [data]="state.data"
  [menuItems]="menuItems"
  [tableRef]="'AppointmentsListComponent'"
  (search)="search()"
  [hideFilters]="filterLess"
>
  <div tableDef>
    <div tableField [field]="'agent'" [header]="'Utente'">
      <ng-template tableColumnFilter>
        <p-dropdown
          class="w-56"
          styleClass="w-56"
          [options]="(usersOptions$ | async) ?? []"
          placeholder="Utente"
          [showClear]="true"
          [filter]="true"
          [ngModel]="state.requestData.filters.agent"
          (ngModelChange)="state.requestData.filters.agent = $event; search()"
        ></p-dropdown>
      </ng-template>
    </div>
    <div tableField [field]="'nominative'" [header]="'Nominativo appuntamento'">
      <ng-template tableColumnFilter>
        <input
          pInputText
          type="text"
          placeholder="Nominativo"
          [(ngModel)]="state.requestData.filters.nominative"
          (keyup.enter)="search()"
        />
      </ng-template>
    </div>
    <div tableField [field]="'state'" [header]="'Stato'">
      <ng-template tableColumnFilter>
        <p-dropdown
          class="w-full"
          styleClass="w-full"
          [options]="(eventStatesOptions$ | async) ?? []"
          placeholder="Stato"
          [ngModel]="state.requestData.filters.state"
          (ngModelChange)="state.requestData.filters.state = $event; search()"
          [showClear]="true"
        ></p-dropdown>
      </ng-template>
    </div>
    <div tableField [field]="'type'" [header]="'Tipo'">
      <ng-template tableColumnFilter>
        <p-dropdown
          class="w-full"
          styleClass="w-full"
          [options]="(eventTypeOptions$ | async) ?? []"
          placeholder="Tipo"
          [ngModel]="state.requestData.filters.type"
          (ngModelChange)="state.requestData.filters.type = $event; search()"
          [showClear]="true"
        ></p-dropdown>
      </ng-template>
    </div>
    <div tableField [field]="'phones'" [header]="'Telefoni'">
      <ng-template tableColumnFilter>
        <input pInputText type="text" placeholder="Telefoni" [(ngModel)]="state.requestData.filters.phone" (keyup.enter)="search()" />
      </ng-template>
    </div>
    <div tableField [field]="'emails'" [header]="'Email'">
      <ng-template tableColumnFilter>
        <input pInputText type="text" placeholder="Email" [(ngModel)]="state.requestData.filters.email" (keyup.enter)="search()" />
      </ng-template>
    </div>
    <div tableField [field]="'createdAt'" [header]="'Data creazione'" [sortable]="true">
      <ng-template tableColumnFilter>
        <range-date-picker
          [ngModel]="state.requestData.filters.createdAt"
          (ngModelChange)="state.requestData.filters.createdAt = $event; search()"
        ></range-date-picker>
      </ng-template>
    </div>
    <div tableField [field]="'isStar'" [header]="'Stella'">
      <ng-template tableColumnFilter>
        <p-dropdown
          [options]="[
            { label: 'Si', value: true },
            { label: 'No', value: false }
          ]"
          placeholder="Stella"
          [showClear]="true"
          [ngModel]="state.requestData.filters.isStar"
          (ngModelChange)="state.requestData.filters.isStar = $event; search()"
        ></p-dropdown>
      </ng-template>
    </div>
    <div tableField [field]="'address'" [header]="'Indirizzo'">
      <ng-template tableColumnFilter>
        <input pInputText type="text" placeholder="Indirizzo" [(ngModel)]="state.requestData.filters.address" (keyup.enter)="search()" />
      </ng-template>
    </div>
    <div tableField [field]="'start'" [header]="'Inizio'" [sortable]="true">
      <ng-template tableColumnFilter>
        <range-date-picker
          [ngModel]="state.requestData.filters.start"
          (ngModelChange)="state.requestData.filters.start = $event; search()"
        ></range-date-picker>
      </ng-template>
    </div>
    <div tableField [field]="'end'" [header]="'Fine'" [sortable]="true">
      <ng-template tableColumnFilter>
        <range-date-picker
          [ngModel]="state.requestData.filters.end"
          (ngModelChange)="state.requestData.filters.end = $event; search()"
        ></range-date-picker>
      </ng-template>
    </div>
    <div tableField [field]="'insertUser'" [header]="'Utente inserimento'">
      <ng-template tableColumnFilter>
        <p-dropdown
          class="w-full"
          styleClass="w-full"
          [options]="(usersOptions$ | async) ?? []"
          placeholder="Utente inserimento"
          [showClear]="true"
          [filter]="true"
          [ngModel]="state.requestData.filters.insertUser"
          (ngModelChange)="state.requestData.filters.insertUser = $event; search()"
        ></p-dropdown>
      </ng-template>
    </div>
    <div tableField [field]="'source'" [header]="'Fonte'">
      <ng-template tableColumnFilter>
        <p-dropdown
          class="w-full"
          styleClass="w-full"
          [options]="(sourceOptions$ | async) ?? []"
          placeholder="Fonte"
          [ngModel]="state.requestData.filters.source"
          (ngModelChange)="state.requestData.filters.source = $event; search()"
          [showClear]="true"
        ></p-dropdown>
      </ng-template>
    </div>
  </div>

  <div tableTabs (tabChange)="onTabChange($event)" *ngIf="!filterLess">
    <div tableTab [label]="'Tutti'"></div>
    <div tableTab [label]="'Eseguito'" [value]="EventStateEnum.ESEGUITO"></div>
    <div tableTab [label]="'Riprogrammato'" [value]="EventStateEnum.RIPROGRAMMATO"></div>
    <div tableTab [label]="'Annullato'" [value]="EventStateEnum.ANNULLATO"></div>
  </div>

  <ng-template actions *ngIf="!filterLess">
    <div>
      <p-dropdown
        [options]="(usersOptions$ | async) ?? []"
        placeholder="Network"
        [ngModel]="state.requestData.filters.network"
        (ngModelChange)="state.requestData.filters.network = $event; search()"
        [showClear]="true"
      ></p-dropdown>
    </div>
    <div>
      <button pButton pRipple label="Download CSV" icon="pi pi-download" class="p-button-secondary mr-2" (click)="downloadCsv()"></button>
    </div>
  </ng-template>
</table-list>
